module.exports = __webpack_public_path__ + "img/circle.23fd1d03.svg";